
define('ldsh!common/templates/notice', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-notice-box ' +
((__t = ( isVisible ? 'is-visible' : '' )) == null ? '' : __t) +
'">\n  <p class="ed-notice-message">' +
((__t = ( text )) == null ? '' : __t) +
'</p>\n</div>\n';

}
return __p
};});

